import { render, staticRenderFns } from "./AdminRecommendedResources.vue?vue&type=template&id=aab5d76c&"
import script from "./AdminRecommendedResources.vue?vue&type=script&lang=js&"
export * from "./AdminRecommendedResources.vue?vue&type=script&lang=js&"
import style0 from "./AdminRecommendedResources.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports